import { render } from "./PlantLiveVideoForm.vue?vue&type=template&id=4698ccb8&scoped=true&ts=true"
import script from "./PlantLiveVideoForm.vue?vue&type=script&lang=ts"
export * from "./PlantLiveVideoForm.vue?vue&type=script&lang=ts"

import "./PlantLiveVideoForm.vue?vue&type=style&index=0&id=4698ccb8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4698ccb8"]])

export default __exports__